export default "__VITE_ASSET__CsIHe508__"